import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Input from 'components/Form/Input'
import Select from 'components/Select'
import { Form, FormItem } from 'components/UIComponents/FormStyles'
import { FooterFlex } from 'modules/Settings/Components/AddtionalInfo/style'
import React from 'react'
import SuccessMessage from 'utils/SuccessMessage'
const clearAll = (setAddMediaDrawer, mediaLinksForm) => {
  setAddMediaDrawer(false)
  mediaLinksForm.resetFields()
}
const AddMediaLinksDrawer = ({
  addMediaDrawer,
  setAddMediaDrawer,
  socialMediaList,
  setSocialMediaList,
  onChangeFormFields,
  mediaOptions,
}) => {
  const [mediaLinksForm] = Form.useForm()

  const onSubmitFormData = formValues => {
    setSocialMediaList(prev => [...prev, formValues])
    onChangeFormFields()
    clearAll(setAddMediaDrawer, mediaLinksForm)
    SuccessMessage('Link added')
  }
  const content = () => {
    return (
      <Form
        scrollToFirstError
        id={'addLinksForm'}
        form={mediaLinksForm}
        layout="vertical"
        onFinish={onSubmitFormData}
      >
        <FormItem
          name="media"
          rules={[
            {
              required: true,
              message: 'Please enter media name.',
            },
          ]}
        >
          <Select
            label={'Media Name *'}
            placeholder="Enter Media Name"
            width="100%"
            OptionData={mediaOptions?.filter(
              item =>
                !socialMediaList
                  ?.map(data => data?.media)
                  ?.includes(item?.value)
            )}
            nameParam="name"
            valueParam="name"
          />
        </FormItem>
        <Input
          width="100%"
          label={'Media Link *'}
          placeholder="Eg: https://facebook.com"
          name="link"
          type="url"
          rules={[
            {
              required: true,
              message: 'Please enter media link.',
            },

            () => ({
              validator(_, value) {
                if (socialMediaList?.map(item => item?.link)?.includes(value)) {
                  return Promise.reject(new Error(`Link already added`))
                }
                return Promise.resolve()
              },
            }),
          ]}
        />
      </Form>
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd centerVertically>
        <Button.Secondary
          onClick={() => clearAll(setAddMediaDrawer, mediaLinksForm)}
          text="Cancel"
          height="38px"
        />
        <Button.Primary
          text={'Add'}
          height="38px"
          form={'addLinksForm'}
          htmlType="submit"
        />
      </FooterFlex>
    )
  }

  return (
    <Drawer
      width="40%"
      title={'Add More Link'}
      placement="right"
      padding="30px"
      headerpadding="16px 30px"
      closable
      onClose={() => clearAll(setAddMediaDrawer, mediaLinksForm)}
      visible={addMediaDrawer}
      content={content()}
      footer={footer()}
    />
  )
}

export default AddMediaLinksDrawer
